// Note: The first file of a module here, must also register the module

import "./invite-list.component";
import "./user-invite.component";

import "./sections";
